<div class="outer-nav">

    <div class="logo-container mb-2">
        <img src="../../../../assets/images/Logo_Dark.svg" alt="Mayne Logo" />
    </div>

    <div class="nav-container" *ngIf="userType != ''">
        <ul>
            <li *ngFor="let x of filterMenu( menu )">
                <mayne-nav-element (clickEvent)="onClickNav($event)" [text]="x.text" [icon]="x.icon"  [path]="x.path"
                    [children]="x.children" [active]="x.active == true"></mayne-nav-element>
            </li>
        </ul>
    </div>

    <div class="sidebar-footer">
        <div class="sidebar-footer--inner">
            <mayne-user-box></mayne-user-box>
        </div>
    </div>
</div>